import {
  NCLTImage,
  CivilLawImage,
  CBIAndEDImage,
  IncomeTaxImage,
  MediationImage,
  LabourLawsImage,
  CriminalLawImage,
  NRITaxationImage,
  ConsumerForumImage,
  ConsultationForNRIsImage,
  MedicoLegalServicesImage,
  CorporateArbitrationImage,
  ArbitrationLitigationImage,
  CorporateLegalMattersImage,
  GSTRelatedLegalMattersImage,
  GeneralLegalConsultationImage,
  IndustrialFactoryDisputesImage,
  AssetRecoveryForBanksNBFCsImage,
  InformationTechnologyCyberLawImage,
  HighCourtRepresentationAcrossIndiaImage,
} from ".";

const services = [
  {
    name: "Criminal Litigation Services",
    metaTitle: "Criminal Litigation Services in Kolkata",
    metaDescription:
      "Trusted criminal litigation services in Kolkata by Innerwork Legal Services. Skilled defense and representation for all criminal cases and legal matters.",
    image: CriminalLawImage,
    urlPath: "criminal-litigation-services-kolkata",
    description:
      "Criminal law provides key legal principles (trumps) to ensure justice and fairness.",
    points: [
      {
        label: null,
        description:
          "Defense representation for various criminal charges (minor offenses to felonies).",
      },
      {
        label: null,
        description:
          "Expertise in white-collar crimes (corporate fraud, banking fraud, cheating, corruption, money laundering).",
      },
      {
        label: null,
        description:
          "Handling blue-collar crimes (robbery, theft, assault, murder, human trafficking, domestic violence).",
      },
      {
        label: null,
        description: "Cases related to drug offenses and juvenile delinquency",
      },
      {
        label: null,
        description:
          "Specialized defense for corporate clients and executives in criminal activities.",
      },
      {
        label: null,
        description:
          "Handling cases under special enactments like the Maharashtra Protection of Interest of Depositors Act, 1999, and the Prevention of Money Laundering Act, 2002.",
      },
      {
        label: null,
        description:
          "Meticulous trial preparation and advocacy (legal research, evidence gathering, witness identification, courtroom strategies).",
      },
      {
        label: null,
        description:
          "Pre-trial negotiations for plea alternatives and charge reduction/dismissal.",
      },
      {
        label: null,
        description:
          "Legal assistance in regulatory enforcement and litigation.",
      },
      {
        label: null,
        description:
          "Expert representation in bail hearings (interim and anticipatory bail).",
      },
      {
        label: null,
        description:
          "Dedicated services for cheque bounce resolution under the Negotiable Instruments Act.",
      },
      {
        label: null,
        description:
          "Money recovery services through criminal proceedings (fraud, cheating, breach of trust).",
      },
      {
        label: null,
        description: "Specialised juvenile defense services.",
      },
      {
        label: null,
        description:
          "Defense against corporate criminal charges (internal investigations, crisis management).",
      },
      {
        label: null,
        description:
          "Assistance in filing criminal appeals and revisions before various courts.",
      },
      {
        label: null,
        description:
          "Preventive legal counseling to mitigate potential criminal liabilities.",
      },
      {
        label: null,
        description:
          "Assisting in seeking the quashing of FIRs and chargesheets.",
      },
      {
        label: null,
        description: "Child/Minor abuse and protection.",
      },
    ],
  },
  {
    name: "Civil Litigation Services",
    metaTitle: "Civil Litigation Services in Kolkata",
    metaDescription:
      "Professional civil litigation services in Kolkata by Innerwork Legal Services. Expert representation in property disputes, contracts, and other civil matters.",
    image: CivilLawImage,
    urlPath: "civil-litigation-services-kolkata",
    description: "Civil law is dictated by key legal principles, including.",
    points: [
      {
        label: null,
        description:
          "Handling a broad spectrum of disputes across various sectors and industries.",
      },
      {
        label: null,
        description:
          "Representation for multinational corporations, government entities, and individuals.",
      },
      {
        label: null,
        description:
          "Commercial suits (recovery of dues, debts, damages from breaches of contract, business operations, partnerships, corporate governance).",
      },
      {
        label: null,
        description:
          "Property disputes (injunctions, ownership declarations, recovery of possession, partition suits, boundary conflicts, succession, probate, title disagreements).",
      },
      {
        label: null,
        description:
          "Intellectual property disputes (patents, trademarks, copyrights, trade secrets, infringement actions, rectification of marks, patent litigation).",
      },
      {
        label: null,
        description:
          "Employment law (wrongful termination, workplace harassment, wage disputes, retaliation claims).",
      },
      {
        label: null,
        description:
          "Environmental litigation (land use, pollution control, waste management, regulatory compliance).",
      },
      {
        label: null,
        description:
          "Tender disputes (challenging unfair trade practices, disqualifications/rejections).",
      },
      {
        label: null,
        description: "Eviction/ejectment suits.",
      },
      {
        label: null,
        description:
          "Money suits/commercial suits (unpaid debts, loans, dues, estate recovery).",
      },
      {
        label: null,
        description:
          "Suit relating to specific performance and contracts (enforcement of contracts and specific performance).",
      },
      {
        label: null,
        description:
          "Other civil disputes (tort claims, consumer disputes, administrative law disputes (CAT), civil defamation suits).",
      },
      {
        label: null,
        description: "Filing and defending writ petitions before High Courts.",
      },
      {
        label: null,
        description:
          "Matters relating to civil division and cases dealt with at the original side of High Court (civil suits and arbitration).",
      },
    ],
  },
  {
    name: "Corporate Legal Matters (including NCLT, SARFAESI, DRT & DRAT)",
    metaTitle:
      "Corporate Legal Services in Kolkata - NCLT, SARFAESI, DRT & DRAT",
    metaDescription:
      "Expert corporate legal services in Kolkata by Innerwork Legal Services. Handle NCLT, SARFAESI, DRT, DRAT cases with trusted support for effective resolution.",
    image: CorporateLegalMattersImage,
    urlPath: "corporate-legal-services-nclt-sarfaesi-drt-drat-kolkata",
    description:
      "Corporate legal matters encompass proceedings related to financial and structural disputes of companies, including cases handled by tribunals like NCLT, SARFAESI actions for asset recovery by banks, and appeals before DRT and DRAT. These mechanisms ensure legal resolution of insolvency, loan defaults, and corporate governance issues.",
    points: [
      {
        label: null,
        description: "National Company Law Tribunal (NCLT):",
        subPoints: [
          {
            label: null,
            description:
              "Assisting financial and operational creditors, and corporate debtors in CIRP applications.",
          },
          {
            label: null,
            description:
              "Handling voluntary winding up proceedings and liquidation processes.",
          },
          {
            label: null,
            description:
              "Representing secured and unsecured creditors in insolvency proceedings.",
          },
          {
            label: null,
            description:
              "Advising and acting for Interim Resolution Professionals (IRPs), Resolution Professionals (RPs), and liquidators.",
          },
          {
            label: null,
            description:
              "Legal guidance and representation in mergers, amalgamations, and corporate restructuring.",
          },
          {
            label: null,
            description:
              "Handling conflicts among shareholders and stakeholders (oppression and mismanagement).",
          },
          {
            label: null,
            description:
              "Assisting in rectification of the register of members.",
          },
          {
            label: null,
            description: "Advising on reduction of share capital.",
          },
          {
            label: null,
            description:
              "Handling petitions for the revival of dormant or struck-off companies.",
          },
          {
            label: null,
            description:
              "Representation in appeals before the National Company Law Appellate Tribunal (NCLAT).",
          },
          {
            label: null,
            description:
              "Conducting legal due diligence for corporate transactions and insolvency matters.",
          },
          {
            label: null,
            description:
              "Assisting with voluntary revision of financial statements and auditor appointments/removals.",
          },
          {
            label: null,
            description:
              "Handling applications for the transfer of shares and debentures.",
          },
          {
            label: null,
            description:
              "Counsel and representation in corporate governance matters.",
          },
        ],
      },
      {
        label: null,
        description:
          "Securitisation and Reconstruction of Financial Assets and Enforcement of Security Interest Act, 2002 (SARFAESI):",
        subPoints: [
          {
            label: null,
            description:
              "Guidance and services related to the SARFAESI Act for NPA recovery by banks and NBFCs.",
          },
          {
            label: null,
            description:
              "Assisting in issuing statutory demand notices under Section 13(2).",
          },
          { label: null, description: "Guiding on NPA classification." },
          {
            label: null,
            description: "Handling borrower objections to demand notices.",
          },
          {
            label: null,
            description:
              "Facilitating possession of secured assets under Section 13(4).",
          },
          { label: null, description: "Arranging valuation of seized assets." },
          {
            label: null,
            description: "Managing the auction process of secured assets.",
          },
          {
            label: null,
            description:
              "Advising on leasing, selling, or assigning secured assets.",
          },
          {
            label: null,
            description:
              "Representing banks/NBFCs in DRT applications under Section 17.",
          },
          {
            label: null,
            description: "Ensuring compliance with SARFAESI Act documentation.",
          },
          {
            label: null,
            description:
              "Guiding on legal limitations and prohibited practices under SARFAESI.",
          },
          {
            label: null,
            description:
              "Assisting in enforcing security interests against borrowers, guarantors, and third parties.",
          },
          {
            label: null,
            description:
              "Facilitating debt-to-equity conversion by banks and ARCs.",
          },
        ],
      },
      {
        label: null,
        description:
          "Debt Recovery Tribunal (DRT) & Debt Recovery Appellate Tribunal (DRAT):",
        subPoints: [
          {
            label: null,
            description:
              "Representation before DRT and DRAT for debt recovery of banks and financial institutions.",
          },
          {
            label: null,
            description:
              "Filing original applications (OAs) before DRT for debts exceeding ₹20 lakh.",
          },
          {
            label: null,
            description:
              "Assisting in obtaining recovery certificates from DRT.",
          },
          {
            label: null,
            description:
              "Representing borrowers/guarantors in filing applications (SAs) under Section 17 of SARFAESI Act.",
          },
          {
            label: null,
            description: "Handling appeals before DRAT against DRT orders.",
          },
          {
            label: null,
            description:
              "Assisting in the enforcement of recovery certificates.",
          },
          {
            label: null,
            description:
              "Representation in DRAT proceedings concerning the value of appeals for court fees.",
          },
          {
            label: null,
            description:
              "Assisting in applications for condonation of delay in filing DRAT appeals.",
          },
          {
            label: null,
            description:
              "Representing clients in appeals against Recovery Officer orders before the DRT Presiding Officer.",
          },
          {
            label: null,
            description:
              "Representing public sector banks, multinational banks, financial institutions, and individual/NRI clients.",
          },
          {
            label: null,
            description:
              "Guidance and representation in negotiating loan settlements and debt restructuring before DRT.",
          },
          {
            label: null,
            description:
              "Assisting borrowers facing improper recovery actions or harassment.",
          },
          {
            label: null,
            description:
              "Representing clients in cases where banks have taken actions under SARFAESI Act.",
          },
        ],
      },
    ],
  },
  {
    name: "Asset Recovery for Banks & NBFCs",
    metaTitle: "Asset Recovery Services for Banks & NBFCs",
    metaDescription:
      "Professional asset recovery services in Kolkata for Banks & NBFCs by Innerwork Legal Services. Resolve NPAs, recover debts, and secure financial interests.",
    image: AssetRecoveryForBanksNBFCsImage,
    urlPath: "asset-recovery-services-banks-nbfcs-kolkata",
    description:
      "Specialized legal support for banks and NBFCs in recovering assets, enforcing security interests, and resolving financial disputes efficiently.",
    points: [
      {
        label: null,
        description: "Issuing legal notices to defaulting borrowers.",
      },
      {
        label: null,
        description: "Taking possession of secured assets under SARFAESI Act.",
      },
      {
        label: null,
        description: "Facilitating valuation of repossessed assets.",
      },
      {
        label: null,
        description: "Managing public auctions or private sales of assets.",
      },
      {
        label: null,
        description:
          "Engaging in negotiation and settlement discussions (OTS, loan restructuring).",
      },
      {
        label: null,
        description:
          "Initiating legal proceedings before DRT and other courts for remaining debt.",
      },
      {
        label: null,
        description:
          "Collaborating with Asset Reconstruction Companies (ARCs).",
      },
      {
        label: null,
        description: "Conducting asset tracing investigations.",
      },
      {
        label: null,
        description:
          "Ensuring compliance with RBI guidelines on loan recovery.",
      },
      {
        label: null,
        description:
          "Assisting in resolving borrower objections against recovery actions.",
      },
      {
        label: null,
        description: "Assisting in the enforcement of personal guarantees.",
      },
      {
        label: null,
        description:
          "Utilizing the Insolvency and Bankruptcy Code (IBC) for corporate insolvency resolution.",
      },
      {
        label: null,
        description:
          "Providing legal advice on securitization of financial assets.",
      },
    ],
  },
  {
    name: "GST-Related Legal Matters (including Registration, Appeals & Resolution)",
    metaTitle: "GST Legal Services in Kolkata - Registration, Appeals & More",
    metaDescription:
      "Expert GST legal services in Kolkata by Innerwork Legal Services. Get help with GST registration, appeals, compliance issues, and dispute resolution.",
    image: GSTRelatedLegalMattersImage,
    urlPath: "gst-legal-services-registration-appeals-kolkata",
    description:
      "GST Registration: End-to-end assistance with GST registration (eligibility, application filing, documentation).",
    points: [
      {
        label: null,
        description: "GST Compliance and Advisory:",
        subPoints: [
          {
            label: null,
            description:
              "Ongoing advisory services on GST laws, rules, and regulations.",
          },
          {
            label: null,
            description:
              "Assisting with preparation and filing of monthly and annual GST returns.",
          },
          {
            label: null,
            description:
              "Guidance on classification of goods/services and applicable tax rates.",
          },
          {
            label: null,
            description:
              "Advising on eligibility and availment of Input Tax Credit (ITC).",
          },
          {
            label: null,
            description:
              "Assisting with preparation and submission of e-way bills.",
          },
          {
            label: null,
            description: "Conducting GST audits and health checks.",
          },
          {
            label: null,
            description:
              "Advising on GST implications of business transactions.",
          },
        ],
      },
      {
        label: null,
        description: "GST Appeals:",
        subPoints: [
          {
            label: null,
            description:
              "Preparing and filing appeals against orders by GST authorities.",
          },
          {
            label: null,
            description:
              "Representation during GST appeal hearings before various forums.",
          },
          {
            label: null,
            description:
              "Guidance on valid grounds for appeal, form completion, fee payment, and documentation.",
          },
          {
            label: null,
            description:
              "Assisting with the process of withdrawing GST appeals.",
          },
          {
            label: null,
            description:
              "Advising on time limits for filing appeals and condonation of delay.",
          },
        ],
      },
      {
        label: null,
        description: "GST Resolution:",
        subPoints: [
          {
            label: null,
            description: "Assisting in preparing responses to GST notices.",
          },
          {
            label: null,
            description:
              "Representation during departmental audits and investigations.",
          },
          {
            label: null,
            description:
              "Assisting in seeking clarifications and advance rulings.",
          },
          {
            label: null,
            description:
              "Exploring alternative dispute resolution mechanisms for GST disputes.",
          },
          {
            label: null,
            description:
              "Assisting with filing and processing GST refund claims.",
          },
          {
            label: null,
            description: "Representing clients in appeals against penalties.",
          },
          {
            label: null,
            description:
              "Advising on the option of compounding offenses under GST.",
          },
        ],
      },
    ],
  },
  {
    name: "Corporate Arbitration",
    metaTitle: "Corporate Arbitration Services in Kolkata",
    metaDescription:
      "Professional corporate arbitration services in Kolkata by Innerwork Legal Services. Resolve business disputes efficiently through expert legal intervention.",
    image: CorporateArbitrationImage,
    urlPath: "corporate-arbitration-services-kolkata",
    description:
      "Corporate Arbitration involves resolving commercial and contractual disputes between companies through a private and legally binding process outside of court. Our firm provides end-to-end arbitration services, including drafting arbitration clauses, representing clients before arbitral tribunals, and enforcing arbitral awards.",
    points: [
      {
        label: null,
        description:
          "Handling disputes arising from breach of contract, mergers and acquisitions, construction projects, intellectual property, finance, international commerce, shareholders/joint ventures, and specific sectors like energy, telecom, and real estate.",
      },
      {
        label: null,
        description:
          "Drafting and reviewing arbitration clauses in commercial contracts.",
      },
      {
        label: null,
        description:
          "Advising on the selection and appointment of named arbitrators.",
      },
      {
        label: null,
        description:
          "Assisting in filing petitions for court appointment of arbitrators.",
      },
      {
        label: null,
        description:
          "Preparing and submitting statements of claim, defence, and other pleadings and whole proceedings of arbitrations.",
      },
      {
        label: null,
        description: "Assisting in gathering and presenting evidence.",
      },
      {
        label: null,
        description: "Providing representation at arbitration hearings.",
      },
      {
        label: null,
        description:
          "Assisting in seeking interim measures of protection from courts.",
      },
      {
        label: null,
        description:
          "Providing counsel in challenging and defending arbitral awards.",
      },
      {
        label: null,
        description:
          "Initiating and defending proceedings for the enforcement of domestic and foreign awards.",
      },
      {
        label: null,
        description:
          "Offering legal opinions and advice on arbitration law and procedure.",
      },
      {
        label: null,
        description:
          "Assisting in exploring mediation and conciliation as alternatives.",
      },
      {
        label: null,
        description: "Commercial and financial disputes.",
      },
    ],
  },
  {
    name: "Family Law Matters",
    metaTitle: "Family Law Legal Services in Kolkata",
    metaDescription:
      "Expert family law legal services in Kolkata by Innerwork Legal Services. We handle divorce, custody, alimony, inheritance, and domestic dispute matters.",
    image: ArbitrationLitigationImage,
    urlPath: "family-law-legal-services-kolkata",
    description:
      "Family law is guided by key legal principles (trumps) to protect the rights and responsibilities of individuals in family relationships.",
    points: [
      {
        label: null,
        description:
          "Handling all aspects of divorce (contested and mutual consent) under various personal laws and the Special Marriage Act.",
      },
      {
        label: null,
        description:
          "Specialized assistance with divorce proceedings for NRIs.",
      },
      {
        label: null,
        description:
          "Child custody and visitation rights, prioritizing the child's welfare.",
      },
      {
        label: null,
        description: "Negotiating fair visitation schedules.",
      },
      {
        label: null,
        description: "Handling inter-country child custody disputes for NRIs.",
      },
      {
        label: null,
        description:
          "Legal support in alimony and maintenance claims (including enforcement and modification).",
      },
      {
        label: null,
        description:
          "Assisting in fair and equitable property division during matrimonial disputes.",
      },
      {
        label: null,
        description:
          "Comprehensive legal support for victims of domestic violence (filing complaints, obtaining protection orders, residence orders, monetary relief).",
      },
      {
        label: null,
        description:
          "Representation for individuals facing false allegations of domestic violence.",
      },
      {
        label: null,
        description:
          "Guiding families through domestic and inter-country adoption processes.",
      },
      {
        label: null,
        description:
          "Assisting in obtaining legal guardianship of minor children.",
      },
      {
        label: null,
        description:
          "Guiding couples through legal separation and drafting separation agreements.",
      },
      {
        label: null,
        description:
          "Drafting, reviewing, and negotiating prenuptial and postnuptial agreements.",
      },
      {
        label: null,
        description: "Handling paternity cases.",
      },
    ],
    extra:
      "These principles uphold fairness, security, and justice in family-related legal matters.",
  },
  {
    name: "High Court Representation Across India",
    metaTitle: "High Court Legal Representation India",
    metaDescription:
      "Get expert High Court legal representation across India from Innerwork Legal Services. Trusted advocates for civil, criminal, property, and constitutional matters.",
    image: HighCourtRepresentationAcrossIndiaImage,
    urlPath: "high-court-legal-representation-india",
    description:
      "Comprehensive legal representation before various High Courts across India, covering civil, criminal, constitutional, and writ matters, ensuring strategic advocacy and procedural compliance.",
    points: [
      {
        label: null,
        description: "Filing and defending writ petitions under Article 226.",
      },
      {
        label: null,
        description:
          "Handling appeals against orders from lower courts, tribunals, and quasi-judicial authorities.",
      },
      {
        label: null,
        description: "Representation in diverse civil matters.",
      },
      {
        label: null,
        description:
          "Experienced representation in criminal appeals, revisions, and bail applications.",
      },
      {
        label: null,
        description:
          "Assisting in filing Special Leave Petitions (SLPs) to the Supreme Court.",
      },
      {
        label: null,
        description: "Handling public interest litigations (PILs).",
      },
      {
        label: null,
        description: "Assisting in seeking interim relief and stay orders.",
      },
      {
        label: null,
        description:
          "Specialized representation in family law, taxation, corporate law, and environmental law matters.",
      },
      {
        label: null,
        description: "Meticulous drafting and filing of legal documents.",
      },
      {
        label: null,
        description: "Expert legal advice and consultation.",
      },
      {
        label: null,
        description: "Meticulous case preparation and strategy development.",
      },
      {
        label: null,
        description:
          "Strong network of advocates for representation across India.",
      },
    ],
  },
  {
    name: "Cybercrime-Related Matters",
    metaTitle: "Cybercrime Legal Services in Kolkata",
    metaDescription:
      "Get expert cybercrime legal services in Kolkata from Innerwork Legal Services. We handle online fraud, data breaches, identity theft, and cyber harassment cases.",
    image: InformationTechnologyCyberLawImage,
    urlPath: "cybercrime-legal-services-kolkata",
    description:
      "Cyber law, also known as internet law or digital law, governs legal issues related to the internet, digital transactions, cybersecurity, and online activities.",
    points: [
      {
        label: null,
        description:
          "Handling online fraud, financial scams, hacking, data breaches, cyberstalking, harassment, digital defamation, cyberbullying, email fraud, spam, cyber terrorism, child pornography, website hijacking, malware attacks, social engineering scams, account takeovers, and cryptocurrency wallet hacking.",
      },
      {
        label: null,
        description:
          "Assisting victims in filing complaints with the National Cyber Crime Reporting Portal.",
      },
      {
        label: null,
        description:
          "Providing legal advice on cybercrime laws and procedures.",
      },
      {
        label: null,
        description:
          "Representation for victims in court (injunctions, takedown notices).",
      },
      {
        label: null,
        description: "Robust defense for individuals accused of cybercrimes.",
      },
      {
        label: null,
        description: "Assisting in gathering and preserving digital evidence.",
      },
      {
        label: null,
        description:
          "Understanding and navigating the Information Technology Act, 2000.",
      },
      {
        label: null,
        description: "Representing clients in various cybercrime cases.",
      },
      {
        label: null,
        description:
          "Assisting in unfreezing bank accounts frozen due to cyber fraud allegations.",
      },
      {
        label: null,
        description:
          "Offering corporate cybersecurity compliance and advisory services.",
      },
      {
        label: null,
        description:
          "Handling matters related to data breaches and privacy violations.",
      },
    ],
    extra:
      "Cyber laws vary by country, with acts like the GDPR (EU), IT Act 2000 (India), CFAA (USA), and others defining legal frameworks for digital activities.",
  },
  {
    name: "Specialized Legal Services & Consultation for NRIs",
    metaTitle: "NRI Legal Services & Consultation in Kolkata",
    metaDescription:
      "Get expert NRI legal services in Kolkata from Innerwork Legal Services. We handle property, family, civil, and inheritance matters for NRIs with trusted support.",
    image: ConsultationForNRIsImage,
    urlPath: "nri-legal-services-consultation-kolkata",
    description:
      "Dedicated legal services tailored for NRIs to address cross-border legal challenges and ensure smooth legal compliance in India.",
    points: [
      {
        label: null,
        description: "Assistance in property disputes and inheritance matters.",
      },
      {
        label: null,
        description:
          "Handling ancestral property, wills, succession certificates, and property partition.",
      },
      {
        label: null,
        description:
          "Services for property management, title searches, and due diligence for real estate investments.",
      },
      {
        label: null,
        description:
          "Expert counsel and representation in NRI divorce and matrimonial issues (in India and overseas).",
      },
      {
        label: null,
        description:
          "Assisting with child custody and visitation rights in cross-border disputes.",
      },
      {
        label: null,
        description:
          "Legal advice and representation in alimony, maintenance, and domestic violence cases involving NRIs.",
      },
      {
        label: null,
        description: "Guidance on repatriation of funds under FEMA.",
      },
      {
        label: null,
        description: "Assistance with Power of Attorney services.",
      },
      {
        label: null,
        description:
          "Legal advice and assistance for NRI investments and business setups in India.",
      },
      {
        label: null,
        description: "Specialized tax advisory services for NRIs.",
      },
      {
        label: null,
        description: "Expert legal representation in NRI criminal matters.",
      },
      {
        label: null,
        description: "Assistance with OCI and PIO card applications.",
      },
      {
        label: null,
        description:
          "Handling legal issues related to NRI marriages and divorces solemnized abroad.",
      },
      {
        label: null,
        description:
          "Representation in NRI consumer disputes and real estate/developer claims.",
      },
    ],
  },
  {
    name: "General Legal Consultation & Representation",
    metaTitle: "General Legal Consultation & Representation in Kolkata",
    metaDescription:
      "Reliable general legal consultation and representation in Kolkata by Innerwork Legal Services. Expert advice and support across civil, criminal, and corporate law.",
    image: GeneralLegalConsultationImage,
    urlPath: "general-legal-consultation-representation-kolkata",
    description:
      "Comprehensive legal consultation and representation across diverse practice areas to ensure tailored solutions and effective client advocacy.",
    points: [
      {
        label: null,
        description:
          "Expert legal advice and consultation across various practice areas.",
      },
      {
        label: null,
        description:
          "Drafting and reviewing legal documents (contracts, agreements, notices, petitions).",
      },
      {
        label: null,
        description:
          "Robust legal representation before various legal forums (district courts, High Courts, Supreme Court, tribunals).",
      },
      {
        label: null,
        description: "Assisting in conducting thorough legal due diligence.",
      },
      {
        label: null,
        description: "Expert guidance on regulatory compliance.",
      },
      {
        label: null,
        description:
          "In-depth legal consultation on diverse subjects (corporate, civil, criminal, family, property, etc.).",
      },
      {
        label: null,
        description:
          "Helping clients understand their legal rights and obligations.",
      },
      {
        label: null,
        description:
          "Providing legal representation to those eligible for free legal aid.",
      },
      {
        label: null,
        description:
          "Offering strategic legal counsel for dispute prevention and risk management.",
      },
      {
        label: null,
        description:
          "Facilitating communication and negotiation between parties.",
      },
    ],
  },
  {
    name: "ADR - Alternative Dispute Resolution",
    metaTitle: "Alternative Dispute Resolution (ADR) Services in Kolkata",
    metaDescription:
      "Effective Alternative Dispute Resolution (ADR) services in Kolkata by Innerwork Legal Services. Resolve disputes efficiently through mediation, arbitration, and negotiation.",
    image: MediationImage,
    urlPath: "alternative-dispute-resolution-adr-kolkata",
    description:
      "Alternative Dispute Resolution (ADR) is dictated by key legal principles to ensure fair, efficient, and cost-effective conflict resolution outside traditional courts.",
    points: [
      {
        label: null,
        description:
          "Expertise in arbitration, mediation, conciliation, negotiation, and Lok Adalats.",
      },
      {
        label: null,
        description:
          "Offering expert arbitration, mediation, and conciliation services.",
      },
      {
        label: null,
        description:
          "Assisting in drafting arbitration agreements and contracts.",
      },
      {
        label: null,
        description:
          "Providing advice on selecting and appointing arbitrators.",
      },
      {
        label: null,
        description:
          "Skilled representation in domestic and international arbitration.",
      },
      {
        label: null,
        description:
          "Providing expert mediation services to facilitate communication.",
      },
      {
        label: null,
        description:
          "Assisting in conciliation processes for amicable settlements.",
      },
      {
        label: null,
        description: "Facilitating negotiation between parties.",
      },
      {
        label: null,
        description:
          "Handling the challenging of arbitral awards and their enforcement.",
      },
      {
        label: null,
        description:
          "Comprehensive consultation and strategy development for ADR.",
      },
      {
        label: null,
        description: "Representing clients in Lok Adalats.",
      },
    ],
  },
  {
    name: "Labour Laws",
    metaTitle: "Labour Law Legal Services in Kolkata",
    metaDescription:
      "Expert labour law legal services in Kolkata by Innerwork Legal Services. Assistance with compliance, disputes, employee rights, and workplace regulations.",
    image: LabourLawsImage,
    urlPath: "labour-law-legal-services-kolkata",
    description:
      "Labour laws are governed by essential legal frameworks that protect employee rights and ensure fair practices in the workplace.",
    points: [
      {
        label: null,
        description:
          "Drafting and review of legally compliant employment contracts are provided.",
      },
      {
        label: null,
        description:
          "Comprehensive advisory services on wage and hour compliance in accordance with Indian labour laws are available.",
      },
      {
        label: null,
        description:
          "Policies to prevent workplace discrimination and harassment are developed and implemented.",
      },
      {
        label: null,
        description:
          "Expert guidance on legal requirements pertaining to employee benefits and compensation is offered.",
      },
      {
        label: null,
        description:
          "Assistance with the legal procedures for termination and redundancy, ensuring compliance with Indian law, is provided.",
      },
      {
        label: null,
        description:
          "Advisory services on adhering to occupational safety and health regulations for a secure workplace are rendered.",
      },
      {
        label: null,
        description:
          "Representation in labour disputes, conciliation proceedings, and litigation before relevant forums across India is undertaken.",
      },
      {
        label: null,
        description:
          "Drafting and review of company policies and employee handbooks to ensure alignment with labour legislation are performed.",
      },
      {
        label: null,
        description:
          "Expert legal counsel on diverse aspects of labour law and employee relations is extended.",
      },
      {
        label: null,
        description:
          "Assistance to employers in negotiations with trade unions and the management of collective bargaining agreements is offered.",
      },
      {
        label: null,
        description:
          "Guidance on the legal framework for engaging contract labour and ensuring comprehensive compliance is provided.",
      },
    ],
  },
  {
    name: "Income Tax",
    metaTitle: "Income Tax Legal Services in Kolkata",
    metaDescription:
      "Professional income tax legal services in Kolkata by Innerwork Legal Services. Get expert help with tax compliance, disputes, appeals, and filings.",
    image: IncomeTaxImage,
    urlPath: "income-tax-legal-services-kolkata",
    description:
      "Income Tax services include strategic advisory, compliance, and representation related to personal and corporate taxation under Indian tax laws. Our firm assists clients with tax planning, filing returns, responding to notices, handling assessments, appeals, and representing before tax authorities and tribunals.",
    points: [
      {
        label: null,
        description:
          "Providing comprehensive legal and advisory services related to Income Tax laws in India.",
      },
      {
        label: null,
        description:
          "Assistance with filing income tax returns for individuals, businesses, and other entities.",
      },
      {
        label: null,
        description:
          "Expert advice on tax planning strategies to optimize tax liabilities and ensure compliance.",
      },
      {
        label: null,
        description:
          "Representation in income tax assessments, reassessments, and scrutiny proceedings before tax authorities.",
      },
      {
        label: null,
        description:
          "Handling appeals before the Commissioner of Income Tax (Appeals) and the Income Tax Appellate Tribunal (ITAT).",
      },
      {
        label: null,
        description:
          "Guidance on TDS (Tax Deducted at Source) compliance and related matters.",
      },
      {
        label: null,
        description:
          "Advice on international taxation and Double Taxation Avoidance Agreements (DTAAs).",
      },
      {
        label: null,
        description: "Assistance in resolving complex tax issues and disputes.",
      },
      {
        label: null,
        description: "Legal opinions on various income tax matters.",
      },
      {
        label: null,
        description:
          "Representation in cases involving tax evasion and other offenses under the Income Tax Act.",
      },
      {
        label: null,
        description:
          "Advisory on tax implications of various transactions and investments.",
      },
      {
        label: null,
        description:
          "Assistance with obtaining PAN (Permanent Account Number) and other tax-related registrations.",
      },
    ],
  },
  {
    name: "CBI / ED Related Matters",
    metaTitle: "CBI & ED Legal Matters in Kolkata",
    metaDescription:
      "Expert legal services in Kolkata for CBI and ED related matters by Innerwork Legal Services. Strong representation in investigations, summons, and enforcement cases.",
    image: CBIAndEDImage,
    urlPath: "cbi-ed-legal-matters-kolkata",
    description:
      "We provide expert legal representation and advisory in matters involving the Central Bureau of Investigation (CBI) and Enforcement Directorate (ED), including cases of corruption, money laundering, and economic offenses. Our team offers strategic defense, assistance during investigations, and guidance to ensure compliance with relevant laws and procedures.",
    points: [
      {
        label: null,
        description:
          "Representation in investigations and proceedings initiated by the Central Bureau of Investigation (CBI) for various criminal offenses, including corruption, bribery, and economic offenses.",
      },
      {
        label: null,
        description:
          "Legal assistance in matters pertaining to the Enforcement Directorate (ED) concerning money laundering, FEMA violations, and other financial irregularities.",
      },
      {
        label: null,
        description:
          "Providing guidance and representation during search and seizure operations, summons, and arrests by the CBI and ED.",
      },
      {
        label: null,
        description:
          "Expertise in handling white-collar crimes investigated by these premier agencies.",
      },
      {
        label: null,
        description:
          "Assisting clients in understanding the intricacies of PMLA (Prevention of Money Laundering Act) and other relevant legislation.",
      },
      {
        label: null,
        description:
          "Strategizing and preparing defense against charges framed by the CBI and ED.",
      },
      {
        label: null,
        description: "Bail applications and appeals in CBI/ED cases.",
      },
      {
        label: null,
        description:
          "Assistance in seeking quashing of FIRs and chargesheets filed by the CBI/ED.",
      },
      {
        label: null,
        description:
          "Advisory on compliance with relevant laws to prevent potential CBI/ED scrutiny.",
      },
    ],
  },
  {
    name: "Industrial & Factory Disputes",
    metaTitle: "Industrial & Factory Dispute Legal Services in Kolkata",
    metaDescription:
      "Resolve industrial and factory disputes in Kolkata with Innerwork Legal Services. Expert legal support for labor issues, compliance, negotiations, and litigation.",
    image: IndustrialFactoryDisputesImage,
    urlPath: "industrial-factory-dispute-legal-services-kolkata",
    description:
      "We offer comprehensive legal support in resolving industrial and factory-related disputes between employers and employees, covering wrongful termination, wage issues, and working conditions. Our services include representation before Labour Courts and Tribunals, assistance in conciliation and arbitration, and expert advice on compliance with key labour legislations.",
    points: [
      {
        label: null,
        description:
          "Representation in disputes arising between employers and employees in industrial and factory settings.",
      },
      {
        label: null,
        description:
          "Handling matters related to wrongful termination, retrenchment, and lay-offs.",
      },
      {
        label: null,
        description:
          "Addressing issues concerning wages, working conditions, and other service conditions.",
      },
      {
        label: null,
        description:
          "Representation before Labour Courts and Industrial Tribunals.",
      },
      {
        label: null,
        description:
          "Assistance in conciliation, mediation, and arbitration proceedings to resolve industrial disputes.",
      },
      {
        label: null,
        description:
          "Legal advice on compliance with the Industrial Disputes Act, Factories Act, and other labour legislations.",
      },
      {
        label: null,
        description:
          "Drafting and reviewing employment contracts and service agreements.",
      },
      {
        label: null,
        description:
          "Handling trade union-related matters and collective bargaining issues.",
      },
      {
        label: null,
        description: "Disputes related to unfair labour practices.",
      },
      {
        label: null,
        description:
          "Matters concerning standing orders and disciplinary actions.",
      },
    ],
  },
  {
    name: "Medico-Legal Services",
    metaTitle: "Medico-Legal Services in Kolkata",
    metaDescription:
      "Trusted medico-legal services in Kolkata by Innerwork Legal Services. Legal support for medical negligence, patient rights, forensic reports, and compliance.",
    image: MedicoLegalServicesImage,
    urlPath: "medico-legal-services-kolkata",
    description:
      "We provide specialized medico-legal services encompassing legal representation and advisory in cases involving medical negligence, malpractice, and hospital-related disputes. Our expertise extends to handling litigation, regulatory compliance, and documentation support for healthcare professionals, institutions, and affected patients.",
    points: [
      {
        label: null,
        description:
          "Providing legal assistance in cases involving medical negligence and deficiency in medical services.",
      },
      {
        label: null,
        description:
          "Representing patients and their families in seeking compensation for medical malpractice.",
      },
      {
        label: null,
        description:
          "Defending medical professionals and healthcare institutions against allegations of negligence.",
      },
      {
        label: null,
        description:
          "Assistance in navigating the legal aspects of patient rights and responsibilities.",
      },
      {
        label: null,
        description:
          "Handling cases before consumer forums and other relevant courts concerning medical issues.",
      },
      {
        label: null,
        description:
          "Advisory on ethical and legal considerations in the medical profession.",
      },
      {
        label: null,
        description:
          "Drafting and reviewing medical consent forms and related documentation.",
      },
      {
        label: null,
        description:
          "Providing guidance on the legal implications of medical records and confidentiality.",
      },
      {
        label: null,
        description:
          "Assistance in cases related to organ transplantation, surrogacy, and other bioethical issues.",
      },
    ],
  },
  {
    name: "Consumer Forum",
    metaTitle: "Consumer Forum Legal Services in Kolkata",
    metaDescription:
      "Expert consumer forum legal services in Kolkata by Innerwork Legal Services. File complaints, resolve disputes, and protect your consumer rights effectively.",
    image: ConsumerForumImage,
    urlPath: "consumer-forum-legal-services-kolkata",
    description:
      "We assist clients in resolving disputes related to defective goods, deficient services, and unfair trade practices through representation before Consumer Forums at all levels. Our team ensures effective legal remedies, including compensation claims and grievance redressal, under the Consumer Protection Act.",
    points: [
      {
        label: null,
        description:
          "Representing consumers in filing complaints against unfair trade practices, defective goods, and deficient services.",
      },
      {
        label: null,
        description:
          "Handling cases before District, State, and National Consumer Disputes Redressal Commissions.",
      },
      {
        label: null,
        description: "Drafting and filing consumer complaints and appeals.",
      },
      {
        label: null,
        description:
          "Providing legal guidance on consumer rights and protection laws.",
      },
      {
        label: null,
        description:
          "Assisting businesses in understanding and complying with consumer protection regulations.",
      },
      {
        label: null,
        description:
          "Representing businesses in defending against consumer complaints.",
      },
      {
        label: null,
        description: "Matters related to product liability and warranties.",
      },
      {
        label: null,
        description:
          "Disputes concerning misleading advertisements and unfair contractual terms.",
      },
      {
        label: null,
        description:
          "Assistance in alternative dispute resolution mechanisms for consumer disputes.",
      },
    ],
  },
  {
    name: "NRI Taxation",
    metaTitle: "NRI Taxation Services in Kolkata",
    metaDescription:
      "Expert NRI taxation services in Kolkata by Innerwork Legal Services. Assistance with income tax filing, DTAA, capital gains, and compliance for NRIs.",
    image: NRITaxationImage,
    urlPath: "nri-taxation-services-kolkata",
    description:
      "We provide comprehensive legal and tax advisory services to Non-Resident Indians (NRIs) on navigating the complexities of Indian taxation. Our services include tax planning, filing income tax returns, optimizing tax liabilities, and ensuring compliance with Double Taxation Avoidance Agreements (DTAAs) and other tax regulations.",
    points: [
      {
        label: null,
        description:
          "Providing expert legal advice and services related to taxation for Non-Resident Indians (NRIs).",
      },
      {
        label: null,
        description:
          "Assistance in understanding and complying with Indian tax laws applicable to NRIs.",
      },
      {
        label: null,
        description: "Filing of income tax returns for NRIs.",
      },
      {
        label: null,
        description: "Guidance on tax planning and optimization for NRIs.",
      },
      {
        label: null,
        description:
          "Advice on Double Taxation Avoidance Agreements (DTAAs) and claiming treaty benefits.",
      },
      {
        label: null,
        description:
          "Matters related to taxation of income earned in India and abroad.",
      },
      {
        label: null,
        description:
          "Issues concerning investment and property taxation for NRIs.",
      },
      {
        label: null,
        description: "Repatriation of funds and related tax implications.",
      },
      {
        label: null,
        description:
          "Obtaining necessary tax certifications and documentation for NRIs.",
      },
    ],
  },
  {
    name: "NCLT (including SEBI related matters)",
    metaTitle: "NCLT & SEBI Legal Services in Kolkata",
    metaDescription:
      "Get expert legal services for NCLT and SEBI matters in Kolkata by Innerwork Legal Services. Corporate dispute resolution, regulatory compliance, and appeals.",
    image: NCLTImage,
    urlPath: "nclt-sebi-legal-services-kolkata",
    description:
      "We provide end-to-end legal services before the National Company Law Tribunal (NCLT), including matters involving SEBI regulations, corporate governance disputes, and shareholder conflicts. Our expertise covers representation in cases related to insider trading, disclosure violations, auditor issues, and the intersection of SEBI directives with insolvency proceedings.",
    points: [
      {
        label: null,
        description:
          "Advisory and strategic counsel on the Insolvency and Bankruptcy Code (IBC), 2016.",
      },
      {
        label: null,
        description:
          "Assisting financial and operational creditors, and corporate debtors in CIRP applications.",
      },
      {
        label: null,
        description:
          "Handling voluntary winding up proceedings and liquidation processes.",
      },
      {
        label: null,
        description:
          "Representing secured and unsecured creditors in insolvency proceedings.",
      },
      {
        label: null,
        description:
          "Advising and acting for Interim Resolution Professionals (IRPs), Resolution Professionals (RPs), and liquidators.",
      },
      {
        label: null,
        description:
          "Legal guidance and representation in mergers, amalgamations, and corporate restructuring.",
      },
      {
        label: null,
        description:
          "Handling conflicts among shareholders and stakeholders (oppression and mismanagement).",
      },
      {
        label: null,
        description: "Assisting in rectification of the register of members.",
      },
      {
        label: null,
        description: "Advising on reduction of share capital.",
      },
      {
        label: null,
        description:
          "Handling petitions for the revival of dormant or struck-off companies.",
      },
      {
        label: null,
        description:
          "Representation in appeals before the National Company Law Appellate Tribunal (NCLAT).",
      },
      {
        label: null,
        description:
          "Conducting legal due diligence for corporate transactions and insolvency matters.",
      },
      {
        label: null,
        description:
          "Assisting with voluntary revision of financial statements and auditor appointments/removals.",
      },
      {
        label: null,
        description:
          "Handling applications for the transfer of shares and debentures.",
      },
      {
        label: null,
        description:
          "Counsel and representation in corporate governance matters.",
      },
      {
        label: null,
        description:
          "Representation before the NCLT in matters involving violations of the Securities and Exchange Board of India (SEBI) regulations.",
      },
      {
        label: null,
        description:
          "Handling issues related to disclosure requirements, insider trading, and other SEBI directives before the NCLT.",
      },
      {
        label: null,
        description:
          "Assisting companies and individuals in navigating the interplay between IBC and SEBI regulations.",
      },
      {
        label: null,
        description:
          "Providing legal support in cases where SEBI has initiated action against corporate entities undergoing insolvency proceedings.",
      },
      {
        label: null,
        description:
          "Representation in matters concerning the attachment and release of properties by SEBI in the context of NCLT proceedings.",
      },
    ],
  },
];

export { services };
